import { render, staticRenderFns } from "./TheFormProducts2.vue?vue&type=template&id=52566c5c&scoped=true&"
import script from "./TheFormProducts2.vue?vue&type=script&lang=ts&"
export * from "./TheFormProducts2.vue?vue&type=script&lang=ts&"
import style0 from "./TheFormProducts2.vue?vue&type=style&index=0&id=52566c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52566c5c",
  null
  
)

export default component.exports